import styled from 'styled-components';
import ScreenSize from '../../../config/screenSizes.json';

export const Container = styled.div`
	display: flex;
	justify-content: space-between;
	flex-direction: column;
	@media screen and (min-width: ${ScreenSize.tabletPlus}px) {
		flex-direction: row;
	}
`;

export const StyledMediaCharts = styled.div`
	width: 502px;
	@media screen and (min-width: ${ScreenSize.tabletPlus + 1}px) and (max-width: ${ScreenSize.laptop}px) {
		width: 415px;
	}
	@media screen and (max-width: ${ScreenSize.tabletPlus}px) {
		width: 100%;
	}
`;

export const Leads = styled.div`
	width: calc(100% - 534px);
	@media screen and (min-width: ${ScreenSize.tabletPlus + 1}px) and (max-width: ${ScreenSize.laptop}px) {
		width: calc(100% - 447px);
	}
	@media screen and (max-width: ${ScreenSize.tabletPlus}px) {
		width: 100%;
		margin-bottom: 32px;
	}
`;
